/* Shared progressive enhancement for simple viewport reveals and disclosures.
   Bespoke storytelling lives in velloria-animations.js. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealObservers = new WeakMap();
  var accordionCleanups = new WeakMap();

  function within(root, selector) {
    var result = [];
    if (root instanceof Element && root.matches(selector)) result.push(root);
    return result.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
  }

  function initReveals(root) {
    var items = within(root, '[data-animate], [data-stagger]').filter(function (item) {
      return !item.hasAttribute('data-reveal-initialized');
    });
    if (!items.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-in');
        item.setAttribute('data-reveal-initialized', 'true');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });

    items.forEach(function (item) {
      item.setAttribute('data-reveal-initialized', 'true');
      revealObservers.set(item, observer);
      observer.observe(item);
    });
  }

  function initAccordions(root) {
    within(root, '[data-accordion]').forEach(function (item, index) {
      if (accordionCleanups.has(item)) return;
      var trigger = item.querySelector('[data-accordion-trigger]');
      var panel = item.querySelector('[data-accordion-panel]');
      if (!trigger || !panel) return;

      var baseId = item.id || ('Accordion-' + Date.now().toString(36) + '-' + index);
      var panelId = panel.id || (baseId + '-panel');
      item.id = baseId;
      panel.id = panelId;
      trigger.setAttribute('aria-controls', panelId);
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;

      var close = function () {
        trigger.setAttribute('aria-expanded', 'false');
        item.classList.remove('is-open');
        if (reducedMotion.matches) {
          panel.hidden = true;
          panel.style.height = '';
          return;
        }
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () { panel.style.height = '0px'; });
      };

      var open = function () {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        item.classList.add('is-open');
        if (reducedMotion.matches) { panel.style.height = 'auto'; return; }
        panel.style.height = '0px';
        requestAnimationFrame(function () { panel.style.height = panel.scrollHeight + 'px'; });
      };

      var onClick = function () {
        if (trigger.getAttribute('aria-expanded') === 'true') close(); else open();
      };
      var onTransitionEnd = function () {
        if (trigger.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
        else panel.hidden = true;
      };

      trigger.addEventListener('click', onClick);
      panel.addEventListener('transitionend', onTransitionEnd);
      accordionCleanups.set(item, function () {
        trigger.removeEventListener('click', onClick);
        panel.removeEventListener('transitionend', onTransitionEnd);
      });
    });
  }

  function init(root) {
    initReveals(root);
    initAccordions(root);
  }

  function destroy(root) {
    within(root, '[data-reveal-initialized]').forEach(function (item) {
      var observer = revealObservers.get(item);
      if (observer) observer.unobserve(item);
      revealObservers.delete(item);
      item.removeAttribute('data-reveal-initialized');
    });
    within(root, '[data-accordion]').forEach(function (item) {
      var cleanup = accordionCleanups.get(item);
      if (cleanup) cleanup();
      accordionCleanups.delete(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
})();

